<div class="row">
  <span class="mb-3">{{ 'meterPoint.meterPointChangeRequest.summary.newPartner.partnerTypeQuestion' | translate }}</span>
  <div class="col-12 col-md-6">
    <div class="form-check">
      <input
        type="radio"
        class="form-check-input"
        value="eigenesUnternehmen"
        id="eigenesUnternehmenRadio"
        name="vertragspartnerRadio"
        data-test="neuerVertragspartner-radio-selectEigenesUnternehmen"
        [checked]="vertriebsPartnerSelection() === VertragspartnerSelectionType.EIGENES_UNTERNEHMEN"
        (change)="onSelectionChange(VertragspartnerSelectionType.EIGENES_UNTERNEHMEN)"
      />
      <label class="form-check-label" for="eigenesUnternehmenRadio">
        {{ 'meterPoint.meterPointChangeRequest.summary.newPartner.partnerTypeOwnCompany' | translate }}
      </label>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="form-check">
      <input
        type="radio"
        id="alternativePartner"
        class="form-check-input"
        name="vertragspartnerRadio"
        data-test="neuerVertragspartner-radio-selectAlternativePartner"
        value="alternativePartner"
        [checked]="vertriebsPartnerSelection() === VertragspartnerSelectionType.ALTERNATIVE_PARTNER"
        (change)="onSelectionChange(VertragspartnerSelectionType.ALTERNATIVE_PARTNER)"
      />
      <label class="form-check-label" for="alternativePartner">
        {{ 'meterPoint.meterPointChangeRequest.summary.newPartner.partnerTypeOther' | translate }}
        <lib-ikp-info-tooltip
          size="xs"
          data-test="neuerVertragspartner-tooltip-alternativerVertragspartnerInfo"
          tooltipText="{{ 'meterPoint.meterPointChangeRequest.summary.newPartner.partnerTypeOtherTooltip' | translate }}"
        />
      </label>
    </div>
  </div>
</div>
